import React, {Component} from 'react'
import {Row, Col, Icon} from 'antd'
import axios from 'axios'
import Slider from 'components/Carousel'
import Footer from 'components/Footer'

import 'styles/homePage.css'

class Homepage extends Component {
  constructor() {
    super();
    this.state = {
      banner: [
        {
          'title': '周边',
          'img': 'feature_1'
        },
        {
          'title': '外卖',
          'img': 'feature_2'
        },
        {
          'title': '生活超市',
          'img': 'feature_3'
        },
        {
          'title': '团购',
          'img': 'feature_4'
        },
        {
          'title': '积分商城',
          'img': 'feature_5'
        },
        {
          'title': '热卖',
          'img': 'feature_6'
        },
        {
          'title': '新店推荐',
          'img': 'feature_7'
        },
        {
          'title': '活动',
          'img': 'feature_8'
        }
      ],
      act: [
        {
          'img': '1',
          'url': 'www.baidu1.com'
        },
        {
          'img': '2',
          'url': 'www.baidu2.com'
        },
        {
          'img': '3',
          'url': 'www.baidu3.com'
        }
      ]
      // banner: [],
      // act: []
    }
  }

  componentDidMount() {
    // this.ajaxAct();
    // this.ajaxBanner();
  }

  render() {
    let that = this;
    return (
      <div className='container'>
        <div className='top-box'>
          <div className='top'>
            <span>购物</span>
            <Icon type='search'/>
          </div>
        </div>
        <div className='home-page content-main'>
          <div className='home-main'>
            <Slider/>
            <div className='home-banner'>
              <Row>
                {
                  that.state.banner.map((item, index) => {
                    return (
                      <Col className='item-banner' span={6} key={index}>
                        <a href=''>
                          <img src={'images/' + item.img + '.png'} alt={item.title}/>
                          <p>{item.title}</p>
                        </a>
                      </Col>
                    )
                  })
                }
              </Row>
            </div>
            <div className='home-act'>
              <Row gutter={6}>
                {
                  that.state.act.map((item, index) => {
                    return (
                      <Col span={8} key={index}>
                        <img onClick={that.act.bind(that, event)} src={'images/' + item.img + '.png'} alt={item.img}/>
                      </Col>
                    )
                  })
                }
              </Row>
            </div>
            <div className='home-item'>
              <h1>猜你喜欢</h1>
              <Row className='item-like'>
                <Col span={8}>
                  <img src='images/like_1.png' alt='牛仔裤'/>
                </Col>
                <Col span={16}>
                  <p>牛仔裤</p>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    )
  }

  ajaxBanner() {
    let that = this;
    axios.get('/api/banner.json').then((response) => {
      if (response.data.success === 0) {
        that.setState({
          banner: response.data.data
        })
      }
    })
  }

  ajaxAct() {
    let that = this;
    axios.get('/api/act.json').then((response) => {
      if (response.data.success === 0) {
        that.setState({
          act: response.data.data
        })
      }
    })
  }

  act(target, event) {
    alert('你当前点击的图片是' + event.currentTarget.getAttribute('alt'));
  }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/pages/homePage.js